import { useState, useEffect } from 'react';
export const usePersistedState = (key, defaultValue) => {
    const [state, setState] = useState(() => {
        const storedValue = localStorage.getItem(key);
        if (storedValue) {
            try {
                // Attempt to parse JSON, if it fails, return storedValue (string)
                return JSON.parse(storedValue);
            }
            catch (error) {
                return storedValue;
            }
        }
        return defaultValue;
    });
    useEffect(() => {
        // Serialize the state before saving it to localStorage
        if (state !== null) {
            localStorage.setItem(key, JSON.stringify(state));
        }
        else {
            localStorage.removeItem(key);
        }
    }, [key, state]);
    return [state, setState];
};
export const useSessionState = (key, defaultValue) => {
    const [state, setState] = useState(() => {
        const storedValue = sessionStorage.getItem(key);
        if (storedValue) {
            try {
                // Attempt to parse JSON, if it fails, return storedValue (string)
                return JSON.parse(storedValue);
            }
            catch (error) {
                return storedValue;
            }
        }
        return defaultValue;
    });
    useEffect(() => {
        // Serialize the state before saving it to sessionStorage
        if (state !== null) {
            sessionStorage.setItem(key, JSON.stringify(state));
        }
        else {
            sessionStorage.removeItem(key);
        }
    }, [key, state]);
    return [state, setState];
};
